<template>
  <div v-if="visit != null" class="row card mt-4">
    <div class="col-12">
      <div class="table-responsive" style="margin: 0px">
        <table id="order-list" class="table table-flush">
          <thead class="thead-light">
            <tr>
              <th class="text-center">Date</th>
              <th class="text-center">Powder Name</th>
              <th class="text-center">Benchmark &amp; Target</th>
              <th class="text-center">Health Check</th>
              <th class="text-center">Guns Equalization</th>
              <th class="text-center">Spray Pattern</th>
              <th class="text-center">Reciprocator</th>
              <th class="text-center">Thickness Adjustment</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="visit.date">
              <visit-row
                :date-time="visit ? dateToString(visit.created_at) : dateToString(new Date())"
                :powder-name="visit.benchmarkstage.powder ? visit.benchmarkstage.powder.name : '-'"
                :benchmark-checked="visit.benchmarkstage ? visit.benchmarkstage.progress_status : 'Pending'"
                :health-checked="visit.healthcheckstage ? visit.healthcheckstage.progress_status : 'Pending'"
                :guns-equalization-checked="visit.gunsequalizationstage ? visit.gunsequalizationstage.progress_status : 'Pending'"
                :spray-pattern-checked="visit.spraypatternstage ? visit.spraypatternstage.progress_status : 'Pending'"
                :reciprocator-checked="visit.reciprocatorstage ? visit.reciprocatorstage.progress_status : 'Pending'"
                :thickness-adjustment-checked="visit.thicknessadjustmentstage ? visit.thicknessadjustmentstage.progress_status : 'Pending'"
                :line-id="lineId"
                :visit-id="visit.id"
                :finalized-at-stage="finalizedAtStage"
              ></visit-row>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import VisitRow from "../../components/VisitRow.vue";
import { dateToString } from "@/views/composables";

export default {
  name: "StepperLineVisit",
  components: {
    VisitRow,
  },
  props: {
    lineId: {
      type: String,
      default: "",
    },
    visit: {
      type: Object,
      default: () => ({}),
    },
    finalizedAtStage: {
      type: String,
      default: "not_finalized",
    },
  },
  data() {
    return {
    };
  },
  methods: {
    dateToString,
  },
};
</script>
